import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class UnderstandSectionUseCase extends BaseUseCase {
    constructor(understandSectionRepo) {
        super();
        this.understandSectionRepo = understandSectionRepo;
    }
    async fetchResult(data) {
        // try {
        //   return await this.understandSectionRepo.getUnderstandingSectionData(
        //     data.reportName,
        //     data.type
        //   );
        // } catch (err) {
        //   return {
        //     reportDetails: [],
        //   };
        // }
        return {
            reportDetails: [],
        };
    }
}
export default UnderstandSectionUseCase;
